module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column h-100"
  }, [_c('auction-header'), _vm._v(" "), _c('div', {
    staticClass: "container-fluid flex-grow-1"
  }, [_c('div', {
    staticClass: "row h-100"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-3 col-lg-2 bg-dark px-0"
  }, [_c('auction-sidebar')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-9 col-lg-10 mt-3"
  }, [_c('b-breadcrumb', {
    attrs: {
      "items": _vm.breadcrumb
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "aucdates": {
        start: _vm.activeAuction.start,
        end: _vm.activeAuction.end
      }
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cd48862"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/AuctionLayout.vue
// module id = 1307
// module chunks = 1